import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            观众热评
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">来自观影同好的真实声音</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {commentsData.map((comment) => (
              <div
                key={comment.id}
                className="bg-background-100 rounded-lg p-5 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-10 h-10 rounded-full object-cover shrink-0"
                    width="40"
                    height="40"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <span className="text-sm font-semibold text-foreground-900 truncate">
                        {comment.name}
                      </span>
                      <span className="text-xs text-foreground-400 shrink-0">{comment.time}</span>
                    </div>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-accent-400 text-xs"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {comment.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}